"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAffiliatesContext = exports.AffiliatesContextProvider = exports.AffiliatesContext = void 0;
var react_1 = require("react");
var React = require("react");
var initialState = {
  isLinkToolbarAvailable: false,
  targetUrl: ''
};
exports.AffiliatesContext = (0, react_1.createContext)(initialState);
var AffiliatesContextProvider = function (_a) {
  var children = _a.children,
    affiliatesContext = _a.affiliatesContext;
  var value = {
    isLinkToolbarAvailable: affiliatesContext.isLinkToolbarAvailable,
    targetUrl: affiliatesContext.targetUrl
  };
  return React.createElement(exports.AffiliatesContext.Provider, {
    value: value
  }, children);
};
exports.AffiliatesContextProvider = AffiliatesContextProvider;
exports.AffiliatesContextProvider.displayName = 'AffiliatesContextProvider';
var useAffiliatesContext = function () {
  return (0, react_1.useContext)(exports.AffiliatesContext);
};
exports.useAffiliatesContext = useAffiliatesContext;